import ProductBatchStockListByProduct from '@/view/components/bills/ProductBatchStockListByProduct.vue';
import { TIME_TRIGGER } from '@/utils/constants';


const productBatchStockMixin = {
  components: {
    ProductBatchStockListByProduct,
  },
  mounted() {
    this.fetchProduct();
  },
  data() {
    return {
      selectedProductStock: {
        productStockId: '',
        productId: '',
      },
      // id các lô đã chọn ở dòng khác cùng SP — truyền vào modal để disable, tránh chọn trùng lô.
      modalExcludedBatchStockIds: [],
    };
  },
  methods: {
    showListProductBatchModal(selectedProductStockFromList) {
      const productStock = this.listProductStock.find(
        (item) => item.id === selectedProductStockFromList.id,
      );
      this.selectedProductStock.productStockId = productStock.id;
      this.selectedProductStock.productId = productStock.proId;
      this.selectedProductStock.productName = productStock.name;
      // Loại các lô đã gán ở DÒNG KHÁC cùng SP (bỏ dòng hiện tại) → chống chọn trùng lô NGAY tại modal,
      // không để tới bước duyệt mới báo "Lô không đủ tồn".
      this.modalExcludedBatchStockIds = this.listProductStock
        .filter(
          (item) =>
            item.id !== productStock.id &&
            item.proId === productStock.proId &&
            item.productBatchStockId,
        )
        .map((item) => item.productBatchStockId);
      setTimeout(() => {
        this.$refs['list-product-batch-modal'].showModal(
          this.selectedProductStock.productId,
          productStock.productBatchStockId || null,
        );
      }, TIME_TRIGGER);
    },
    applyProductBatchStockCode(productBatchStockId, productBatchStockCode) {
      const productStock = this.listProductStock.find(
        (item) => item.id === this.selectedProductStock.productStockId,
      );
      const productStockIndex = this.listProductStock.findIndex(
        (item) => item.id === this.selectedProductStock.productStockId,
      );

      this.$set(productStock, 'productBatchStockId', productBatchStockId);
      this.$set(productStock, 'productBatchStockCode', productBatchStockCode);

      this.$set(this.listProductStock, productStockIndex, productStock);
    },
  },
};
export default productBatchStockMixin;
